import React, { useState } from 'react'
import {fire} from "../../firebase/config";
const VK = window.VK

function RegistrModal(props) {
  const [form, setForm] = useState({ email: "", password: "" ,name:""});

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    console.log(form);
  };
  const registerHandler = async () => {
    fire.auth().createUserWithEmailAndPassword(form.email, form.password)
    .then(() => {
      fire
        .auth()
        .signInWithEmailAndPassword(form.email, form.password)
        
    })
    .then(() => submit());
  };
 const submit=()=> {

    fire
      .database()
      .ref("/users/" + fire.auth().currentUser.uid)
      .set({
       name:form.name,
       balance:0
      }).then(()=>console.log("ok"))
      .catch(()=>console.log("errr"))
      
  }

  const registerWithVk=()=>{
    VK.Auth.login(r => {
      if (r.session) {
        setForm({name:r.session.user.first_name,email:r.session.user.id+"@mail.ru",password:r.session.user.id+2400})
        console.log(form.email,form.password);
        registerHandler()
      } else {
       
      }
    })
  }
    const handleClose=(e)=>{
      console.log(e.target.id);
      if(e.target.id==="inmodal"){
        props.closeFu()
      }
    }
    return (
        <div onClick={handleClose} class="inmodal" id="inmodal">
      <div class="inmodal__content">
        <div class="close__in"></div>
        <div class="inmodal_rcontent">
          <div action="#" class="inmodal__form inmodal-form">
            <div class="inmodal-form__box-name">
              <input
                type="text"
                name="name"
                class="inmodal-form__name"
                onChange={handleChange}
                placeholder="Имя Пользователя"
              />
            </div>
            <div class="inmodal-form__box-mail">
              <input
                type="text"
                name="email"
                onChange={handleChange}
                class="inmodal-form__mail"
                placeholder="E-mail"
              />
            </div>
            <div class="inmodal-form__box-password">
              <input
                type="text"
                onChange={handleChange}
                class="inmodal-form__password"
                name="password"
                placeholder="Пароль"
              />
            </div>
            <div class="inmodal-form__forget">
              <div class="inmodal-form-ff">
                <input
                  type="checkbox"
                  class="inmodal-form__checked"
                  id="inmodal-form__checked"
                />
                <label for="inmodal-form__checked">
                  Я принимаю оферту гаранта и политику конфиденциальности,
                  согласен с получением уведомлений и новостей на почту
                </label>
              </div>
            </div>
            <button class="inmodal__btn" onClick={registerHandler}>Зарегестрироваться</button>

            <div class="inmodal-form__goin">
              Или быстро войти через соцсети
            </div>
            <div class="inmodal-form__icons d-flex" onClick={registerWithVk}>
              <div class="indalup__icon">
                <img src="img/modalsoc1.svg" alt="icon" />
              </div>
              <div class="modalup__icon">
                <img src="img/modalsoc2.svg" alt="icon" />
              </div>
              <div class="modalup__icon">
                <img src="img/modalsoc3.svg" alt="icon" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    )
}

export default RegistrModal
